import { render, staticRenderFns } from "./bottommenu.vue?vue&type=template&id=4e02d9ee&scoped=true&"
import script from "./bottommenu.vue?vue&type=script&lang=js&"
export * from "./bottommenu.vue?vue&type=script&lang=js&"
import style0 from "./bottommenu.vue?vue&type=style&index=0&id=4e02d9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e02d9ee",
  null
  
)

export default component.exports